// 轨迹数据,供中企微课堂服务，查询轨迹记录H5页面
import request from "@/utils/request-for-wkt";

const scope = '';

export function getHistoryRecord(query) {
    return request({
        url: scope + "/exueyun-client-learning/deviceAbutment/getHistoryRecord",
        method: "post",
        data: query
    });
}